import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './faq-header.magic.css.js';
import script from './faq-header.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",attrs:{"part":"header"}},[_c('div',{staticClass:"links",attrs:{"part":"links"}},[_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","data-v-test-id":"faq-header-live-chat","to":_vm.RoutablePage.LIVE_CHAT}},[_c('span',{staticClass:"inner",attrs:{"part":"inner"}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"message","part":"icon"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('faqs.live-chat')}})],1)]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"part":"link","data-v-test-id":"faq-header-email","href":("mailto:" + (_vm.$t('faqs.email')))}},[_c('span',{staticClass:"inner",attrs:{"part":"inner"}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"email","part":"icon"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('faqs.email-us')}})],1)])],1),_vm._v(" "),_c('magic-ui-search-field',{staticClass:"search-field",attrs:{"part":"search-field","data-v-test-id":"faq-header-search","placeholder":_vm.$t('faqs.search-placeholder'),"value":(_vm.searchText)},on:{"input":function($event){_vm.searchText=$event.detail[0];}}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-17974fcc_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-17974fcc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
